import { RegisterCompanyContract } from 'models/RegisterCompanyContract'
import { PostHog } from 'posthog-js/react'
import {
    CurrentClientContract,
    PublicTenantIdentifierInfoContract,
    UserDataContract,
} from 'models'

const getSubdomain = (url: string) => {
    let domain = url
    if (url.includes('://')) {
        domain = url.split('://')[1]
    }
    const subdomain = domain.split('.')[0]
    return subdomain
}

const posthogIntegration = {
    setGroup(
        posthog: PostHog,
        tenantIdentifierInfo: PublicTenantIdentifierInfoContract,
    ) {
        if (posthog && tenantIdentifierInfo?.companyID) {
            posthog.group(
                'company',
                `companyID:${tenantIdentifierInfo.companyID}`,
                {
                    companyID: tenantIdentifierInfo.companyID,
                    companyName: tenantIdentifierInfo.companyName,
                },
            )
        }
    },
    setIdentify(
        posthog: PostHog,
        user: UserDataContract,
        tenantIdentifierInfo: PublicTenantIdentifierInfoContract,
        client: CurrentClientContract,
    ) {
        if (
            posthog &&
            posthog.config?.token &&
            user?.userName &&
            client?.name
        ) {
            // Set user identity to be tracked by PostHog
            // https://posthog.com/docs/integrate/identifying-users
            posthog.identify(
                `${user.userName!}-${getSubdomain(window.location.host)}`,
                {
                    clientName: client.name,
                    clientID: client.clientID,
                }, // $set, optional
                {
                    userID: user.userId,
                    userName: user.userName,
                    userNameWithSubdomain: `${user.userName!}-${getSubdomain(
                        window.location.host,
                    )}`,
                    userEmail: user.email,
                    companyID: tenantIdentifierInfo.companyID,
                    companyName: tenantIdentifierInfo.companyName,
                    locationID: tenantIdentifierInfo.locationID,
                    locationName: tenantIdentifierInfo.locationName,
                    licenseOfferType:
                        tenantIdentifierInfo.companyLicense?.licenseOfferType,
                    // $set_once, optional)
                },
            )
        }
    },
    reset(posthog: PostHog) {
        if (posthog && posthog.config?.token) {
            // reset PostHog tracked User identity after logout
            // https://posthog.com/docs/integrate/client/js#reset-after-logout
            posthog.reset()
        }
    },
    captureRegistration(posthog: PostHog, payload: RegisterCompanyContract) {
        if (posthog && posthog.config?.token) {
            posthog.capture('Company Registration', flatten(payload))
        }
    },
    captureCloseOfDay(posthog: PostHog) {
        if (posthog && posthog.config?.token) {
            posthog.capture('Close Of Day')
        }
    },
}

function flatten(data: any) {
    return Object.assign(
        {},
        ...(function _flatten(o): any {
            return [].concat(
                ...Object.keys(o).map((k) =>
                    typeof o[k] === 'object' ? _flatten(o[k]) : { [k]: o[k] },
                ),
            )
        })(data),
    )
}

export default posthogIntegration
